import { useState } from "react";
import ModuleFieldsPicker from "../../TableLayouts/ModuleFieldsPicker";
import useModule from "../../../hooks/useModule";
import RequiredTitle from "../../../elements/RequiredTitle";
import { SelectPicker } from "rsuite";
import { CalendarConfig } from "../AddViewDrawer/AddViewDrawer";
import { Field } from "../../../types/TenantInterfaces";

interface Props {
  calendarConfig: CalendarConfig;
  setCalendarConfig: React.Dispatch<React.SetStateAction<CalendarConfig>>;
  moduleAPIName: string | undefined;
}

export default function CalendarConfigComponent({
  calendarConfig,
  setCalendarConfig,
  moduleAPIName,
}: Props) {
  const [error, setError] = useState<{ message: string } | null>(null);
  const { module } = useModule(moduleAPIName);

  if (!module) return null;

  const startDateTimeFields: Field[] =
    module?.Fields?.flatMap((f) => {
      if (f.APIName === calendarConfig.EndField) return [];
      if (f.FieldType !== "DateTime" && f.FieldType !== "Date") return [];

      return [f];
    }) || [];

  const endDateTimeFields: Field[] =
    module?.Fields?.flatMap((f) => {
      if (f.APIName === calendarConfig.StartField) return [];
      if (f.FieldType !== "DateTime" && f.FieldType !== "Date") return [];

      return [f];
    }) || [];

  return (
    <>
      <h4 className="mb-0 text-nowrap mr-2 mt-3">Start Date Field:</h4>
      <div className="small mb-2">
        Date/Time field that will be used to specify an Event's start
      </div>
      <SelectPicker
        className="w-100"
        preventOverflow
        data={startDateTimeFields}
        labelKey="Name"
        valueKey="APIName"
        value={calendarConfig.StartField}
        onChange={(field) => {
          if (typeof field !== "string") return;
          setCalendarConfig((prev) => ({ ...prev, StartField: field || "" }));
        }}
      />

      <h4 className="mb-0 text-nowrap mr-2 mt-3">End Date Field: </h4>
      <div className="small mb-2">
        Date/Time field that will be used to specify an Event's end
      </div>
      <SelectPicker
        className="w-100"
        preventOverflow
        data={endDateTimeFields}
        labelKey="Name"
        valueKey="APIName"
        value={calendarConfig.EndField}
        onChange={(field) => {
          if (typeof field !== "string") return;
          setCalendarConfig((prev) => ({ ...prev, EndField: field || "" }));
        }}
      />

      <RequiredTitle size="md" title="Select Fields" className="mt-3" />
      <div className="small mt--2 mb-2">
        Fields you want to display in record detail event
      </div>
      <ModuleFieldsPicker
        module={module}
        availableFields={module?.Fields || []}
        values={calendarConfig.Fields}
        setValues={(newFields) => {
          setCalendarConfig((prev) => ({ ...prev, Fields: newFields }));
        }}
        layoutLimit={4}
        setError={setError}
        onChange={(newFields) =>
          setCalendarConfig((prev) => ({ ...prev, Fields: newFields }))
        }
        placeholder="Select Event Fields"
      />
    </>
  );
}
